module.exports = __webpack_public_path__ + "97fc2bb1e4bf6327494ab48fbb0fe43e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/dianli_c.png
// module id = 272
// module chunks = 3